/* @ngInject */
export default function CssTransitionService() {
    return {
        cssTransitionCallback: function (el, callBack) {
            var transitions = {
                    'transition': 'transitionend',
                    'OTransition': 'oTransitionEnd',
                    'MozTransition': 'transitionend',
                    'WebkitTransition': 'webkitTransitionEnd'
                },
                transition;

            for (transition in transitions) {
                if (el.style[transition]) {
                    if (el.addEventListener) {
                        el.addEventListener(transition, callBack, false);
                    } else {
                        el.attachEvent(transition, callBack, false);
                    }
                }
            }

            //jQuery(el).bind('transitionend oTransitionEnd transitionend webkitTransitionEnd', callBack);
        }
    };
}
